import React from 'react';

const Logo = ({ size = 'default' }) => {
  const dimensions = {
    small: { width: 32, height: 32, fontSize: 'text-sm' },
    default: { width: 48, height: 48, fontSize: 'text-2xl' },
    large: { width: 56, height: 56, fontSize: 'text-3xl' },
  };

  const dim = dimensions[size] || dimensions.default;

  return (
    <div className='flex items-center gap-3'>
      <img
        src='/yamai-logo.png'
        alt='Yamai Logo'
        width={dim.width}
        height={dim.height}
        className='transition-transform duration-300 hover:scale-110'
        style={{ objectFit: 'contain' }}
      />
      <span className={`font-bold text-white tracking-tight ${dim.fontSize}`}>
        Yamai
      </span>
    </div>
  );
};

export default Logo;
